import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.string.trim";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getActivityList, getActivityDetail, createActivity, deleteActivity, auditActivity, updateActivityStatus, downloadActivity } from '@/api/bairun/oilActivity'; //  此处请自行替换地址

import { getTicketRuleDetail } from '@/api/bairun/ticket'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'ExchangeCodeActivity',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getActivityList,
      type: '',
      path: process.env.VUE_APP_BASE_API,
      discountLevel: 1,
      activityType: 100009,
      fullscreenLoading: false,
      multipleSelection: [],
      addDialogVisible: false,
      viewDialogVisible: false,
      auditDialogVisible: false,
      dialogTitle: '',
      dateRangeValueArr: [],
      formData: {}
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.formData = _this3.initData();
                _this3.searchInfo.discountLevel = _this3.discountLevel;
                _this3.searchInfo.activityType = _this3.activityType;

                _this3.getTableData();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        activityNo: '',
        activityName: '',
        activityStatus: 2,
        dateStart: '',
        dateEnd: '',
        exchangeTicketList: [this.initTicketSingle()],
        auditStatus: 2,
        auditRemark: '',
        isRepeat: 0,
        perdayLimit: 1,
        allLimit: 1,
        batchMode: 1,
        points: 0,
        num: 1,
        code: ''
      };
      return formdata;
    },
    initTicketSingle: function initTicketSingle() {
      return {
        ticketRuleNo: '',
        num: 1
      };
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {};
      this.searchInfo.discountLevel = this.discountLevel;
      this.searchInfo.activityType = this.activityType;
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 添加券
    onAddTicket: function onAddTicket(index) {
      var that = this;
      that.formData.exchangeTicketList.splice(index + 1, 0, that.initTicketSingle());
    },
    // 删除券
    onDeleteTicket: function onDeleteTicket(index) {
      debugger;
      var that = this;

      if (that.formData.exchangeTicketList.length == 1) {
        return;
      }

      that.formData.exchangeTicketList.splice(index, 1);
    },
    // 获取券详情
    getTicketDetail: function getTicketDetail(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(item.ticketRuleNo.trim() != '')) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 3;
                return getTicketRuleDetail({
                  'ticketRuleNo': parseFloat(item.ticketRuleNo)
                });

              case 3:
                res = _context4.sent;

                if (res.code == 0) {
                  item.ticketRuleNo = res.data.ticketRuleNo + '';
                } else {
                  item.ticketRuleNo = '';
                }

              case 5:
                _this4.$forceUpdate();

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 新增
    onAdd: function onAdd() {
      this.type = 'add';
      this.addDialogVisible = true;
      this.dialogTitle = '新增兑换码批次';
    },
    // 查看
    onRowdbclick: function onRowdbclick(row) {
      var that = this;
      that.onView(row);
    },
    onView: function onView(row) {
      this.type = 'view';
      this.dialogTitle = '查看兑换规则';
      this.viewDialogVisible = true;
      this.handleViewOrUpdate(row);
    },
    toCodeList: function toCodeList(row) {
      var params = {
        activityNo: row.activityNo
      };
      this.$router.push({
        name: 'ExchangeCodeRecord',
        params: params
      });
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      var _this5 = this;

      var that = this;
      getActivityDetail({
        'activityNo': row.activityNo
      }).then(function (res) {
        that.formData.activityNo = res.data.activityMain.activityNo;
        that.formData.activityName = res.data.activityMain.activityName;
        that.formData.activityStatus = res.data.activityMain.activityStatus;
        that.formData.dateStart = that.$options.filters.formatDate(res.data.activityMain.dateStart);
        that.formData.dateEnd = that.$options.filters.formatDate(res.data.activityMain.dateEnd); // 不能用以下写法，回显会不展示
        // that.dateRangeValueArr[0] = that.$options.filters.formatDate(row.dateStart)
        // that.dateRangeValueArr[1] = that.$options.filters.formatDate(row.dateEnd)

        that.dateRangeValueArr = [that.formData.dateStart, that.formData.dateEnd];
        that.formData.auditStatus = res.data.activityMain.auditStatus;
        that.formData.auditRemark = res.data.activityMain.auditRemark;
        that.formData.isRepeat = res.data.activityMain.activityMainRule.isRepeat;
        that.formData.perdayLimit = res.data.activityMain.activityMainRule.perdayLimit;
        that.formData.allLimit = res.data.activityMain.activityMainRule.allLimit;
        var exchangeJson = JSON.parse(res.data.activitySubExchange.exchangeJson);
        that.formData.exchangeTicketList = exchangeJson.coupons || [];
        that.formData.points = exchangeJson.points || 0;
        _this5.formData.num = res.data.activitySubExchange.num;
        _this5.formData.codeRepeatNum = res.data.activitySubExchange.codeRepeatNum;
      }, function (error) {});
    },
    // 审核
    onAudit: function onAudit(row) {
      this.type = 'audit';
      this.auditDialogVisible = true;
      this.dialogTitle = '审核操作';
      this.formData.activityNo = row.activityNo;
    },
    handleAudit: function handleAudit() {
      var that = this;
      auditActivity({
        'activityNo': this.formData.activityNo,
        'auditStatus': this.formData.auditStatus,
        'auditRemark': this.formData.auditRemark
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 启用
    onAble: function onAble(row) {
      var that = this;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 1
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 禁用
    onDisable: function onDisable(row) {
      var that = this;
      updateActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 2
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    // 删除
    onDelete: function onDelete(row) {
      var that = this;
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteActivity({
          'activityNo': row.activityNo
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    onDownload: function onDownload(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var param;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                param = {
                  'dataType': 1,
                  'activityNo': row.activityNo
                };

                _this6.$confirm('确定要下载吗?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return downloadActivity(param);

                        case 2:
                          res = _context5.sent;

                          if (res.code == 0) {
                            saveAs(res.data.fileUrl);
                          }

                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                })));

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    closeDialog: function closeDialog() {
      this.addDialogVisible = false;
      this.viewDialogVisible = false;
      this.auditDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.dateRangeValueArr = [];
      this.formData = this.initData();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;

      switch (that.type) {
        case 'add':
          that.handleAdd();
          break;

        case 'audit':
          that.handleAudit();
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var that;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                that = _this7;

                if (that.validFormData()) {
                  createActivity(that.getParam()).then(function (res) {
                    if (res.code == 0) {
                      that.$message({
                        type: 'success',
                        message: res.msg
                      });
                      that.enterDialogRepose(res);
                    }
                  }, function (error) {});
                }

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    // 公共校验函数
    validFormData: function validFormData() {
      var that = this;

      if (!that.formData.activityName) {
        that.$message({
          type: 'warning',
          message: '批次名称不能为空'
        });
        return false;
      }

      if (that.dateRangeValueArr.length == 0) {
        that.$message({
          type: 'warning',
          message: '活动时间不能为空'
        });
        return false;
      }

      if (that.formData.batchMode === 1 && !this.formData.num) {
        that.$message({
          type: 'warning',
          message: '生成兑换码数量非法'
        });
        return false;
      }

      if (that.formData.batchMode === 2 && !this.formData.code.trim()) {
        that.$message({
          type: 'warning',
          message: '请输入自定义兑换码'
        });
        return false;
      }

      if (!that.formData.perdayLimit) {
        that.$message({
          type: 'warning',
          message: '单个用户每天可兑换次数非法'
        });
        return false;
      }

      if (!that.formData.allLimit) {
        that.$message({
          type: 'warning',
          message: '单个用户本批次最多可兑换次数非法'
        });
        return false;
      }

      var hasTicket = that.formData.exchangeTicketList.filter(function (item) {
        return item.ticketRuleNo.trim() !== '' && item.num > 0;
      }).length;

      if (!hasTicket && !this.formData.points) {
        that.$message({
          type: 'warning',
          message: '请输入兑换券或积分'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      var that = this;
      var formData = JSON.parse(JSON.stringify(that.formData));
      var param = {
        activityNo: formData.activityNo,
        activityName: formData.activityName,
        activitySellerType: this.discountLevel,
        activityType: this.activityType,
        activityStatus: formData.activityStatus,
        dateStart: this.dateRangeValueArr[0],
        dateEnd: this.dateRangeValueArr[1],
        activityMainInfo: {},
        activityMainRule: {
          isNewRegister: 2,
          isNewPay: 2,
          isNeedShare: 2,
          isLimitGoods: 2,
          isLimitSeller: 2,
          isRepeat: this.formData.isRepeat,
          perdayLimit: this.formData.perdayLimit,
          allLimit: this.formData.allLimit
        },
        activitySubExchange: {
          exchangeJson: JSON.stringify({
            'coupons': this.formData.exchangeTicketList.filter(function (item) {
              return item.ticketRuleNo.trim() !== '' && item.num > 0;
            }),
            'points': this.formData.points
          }),
          num: this.formData.batchMode === 1 ? this.formData.num : 1,
          codeRepeatNum: this.formData.codeRepeatNum,
          code: this.formData.batchMode === 1 ? '' : this.formData.code.trim()
        }
      };
      return param;
    }
  }
};